import React from "react";
import { ConfigProvider } from "antd";
import { FanthonContextProvider } from "../../contexts/FanthonContext";
import { ElementsContextProvider } from "../../contexts/ElementsContext";

import "antd/dist/antd.variable.min.css";

function Elements({ children, fanthon }) {
  ConfigProvider.config({
    theme: {
      primaryColor: fanthon?.primary_color || "#00b96b",
    },
  });

  return (
    <FanthonContextProvider data={fanthon}>
      <ConfigProvider>
        <ElementsContextProvider>{children}</ElementsContextProvider>
      </ConfigProvider>
    </FanthonContextProvider>
  );
}

export default Elements;
